import type { Home } from '@lmc/ts-common'
import { getNominative } from 'common/utils'
import useResidentsList from 'hooks/useResidentsList'
import type { FC } from 'react'
import { useSelector } from 'react-redux'
import { SkillsRequired } from 'screens/Rostering/formComponents'
import useUserSkills from 'screens/Rostering/hooks/useUserSkills'
import type { ModalSectionProps, RotaPatternModalType } from '../utils'

export const SkillsRequiredSection: FC<
  ModalSectionProps & { type?: RotaPatternModalType }
> = ({ formData, type }) => {
  const selectedResident = formData?.serviceUserPattern

  const { residents } = useResidentsList({})

  const foundResident = residents?.find(
    (resident) => resident?.id === selectedResident
  )

  const { allSkills } = useUserSkills()

  const preferredPeopleNominative = useSelector(
    (state: { global: { home: Home } }) =>
      state.global.home.preferredPeopleNominative
  )
  const residentNominative = getNominative(
    preferredPeopleNominative,
    'resident'
  )

  return (
    <SkillsRequired
      type={type}
      nameBasedOne={foundResident?.name?.first || residentNominative}
      skillOptions={[
        ...allSkills.map((skill) => ({ value: skill?.id, label: skill?.name }))
      ]}
      maxValue={formData?.numberSupply}
    />
  )
}
